import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDU0u0VkFoiTDS2fjm9AYMd7klK6feyP0c",
  authDomain: "legal-advice-e7d37.firebaseapp.com",
  projectId: "legal-advice-e7d37",
  storageBucket: "legal-advice-e7d37.firebasestorage.app",
  messagingSenderId: "125216135275",
  appId: "1:125216135275:web:f268bf47f6334c3007392e",
  measurementId: "G-GZPCLNZCZ4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);